export const TABS = {
    CREATE: { value: "CREATE", text: "생성" },
    SELECT: { value: "SELECT", text: "공고" },
    SEARCH: { value: "SEARCH", text: "검색" },
    FINISH: { value: "FINISH", text: "완료료" },
};
